import React from 'react';
import Button from 'components/atoms/Button';

const EstimateHeader = ({ generateJobId, isView, loading, onFormSubmit }) => {
  return (
    <div className="top-header">
      <div className="header-left">
        <span className="job-id-label">Job ID: {generateJobId}</span>
        <span className="status-badge">{isView ? 'Viewing Estimation' : 'Estimation in Progress'}</span>
      </div>
      <div className="header-right">
        {!isView && (
          <Button type="primary" loading={loading} className="btn-finalize-large" onClick={onFormSubmit}>
            Create Quote <i className="material-icons-outlined">arrow_forward</i>
          </Button>
        )}
      </div>
    </div>
  );
};

export default EstimateHeader;
